/*
 * internalstoreReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 22-May-2024
 */
import produce from 'immer'
import { actionTypes } from '../actions/internalstore'

const ACTION_HANDLERS = {
  [actionTypes.STATUS_IDLE]: produce((draft) => {
    draft.status = 'idle'
  }),
  [actionTypes.DO_TOGGLE_SIDEBAR]: produce((draft, action) => {
    draft.sidebar.expanded = action.payload
  })
  // @generator reducer:type:action
}

// The initial state of the internalstore
const initialState = {
  status: '',
  sidebar: {
    expanded: true
  }
}

const internalstore = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default internalstore
